/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * areChildrenHidden
 * Check if the children are hidden
 * @param itemChildren
 * @returns {boolean}
 */
export const areChildrenHidden = (itemChildren) => {
    const hidden = itemChildren.filter((webpage) => {
        return (webpage.hide_in_nav === true || webpage.hide_in_nav === 1);
    });
    return hidden.length === itemChildren.length;
};

/**
 * checkSiblingGuids
 * @param openMenus
 * @param guid
 * @param tree
 * @returns {string}
 */
export const checkSiblingGuids = (openMenus, guid, tree) => {
    let omRemove = "";
    const isSameLevel = tree.filter((treeNode) => treeNode.guid === guid);
    if (isSameLevel.length > 0) {
        const treeGuids = tree.map((treeNode) => treeNode.guid);

        for (let guid of treeGuids) {
            for (let openMenuGuid of openMenus) {
                if (openMenuGuid === guid) {
                    omRemove = guid;
                }
            }
        }
    }

    // value that should be removed from openMenus
    return omRemove;
};
